import styled from "styled-components";

const AdminActions = styled.div`
  display: flex;
  gap: 0.6rem;
  margin-top: ${({ $compact }) => ($compact ? "0.8rem" : "0.9rem")};
`;

export default AdminActions;
